/** @jsxImportSource @emotion/react */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {RouterProvider, createBrowserRouter} from "react-router-dom";
import LP from "./pages/LP";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/Dashboard";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: "/",
        element: <LP />,
    },
    {
        path: "/sign_in",
        element: <SignIn />
    },
    {
        path: "/dashboard",
        element: <Dashboard />
    }
]);

const app = (
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

root.render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
